module.exports = __webpack_public_path__ + "static/media/7bb8e21f-a666-450f-b270-35a7aa28c2ab_1.8fe39480ea2c3a028b9f59d7d5df23ee.400d41a5.jpeg";